import { useEffect, useState } from "react";
import TestimonyCard from "./TestimonyCard";
import TestimonyModal from "./TestimonyModal";
import { TESTIMONIES } from "./testimony.data";
import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
import VideoSection from "./VideoSection";

const TestimonyWrapper = () => {
  const [activeTestimony, setActiveTestimony] = useState<any>(null);
  const title = useFadeInScroll<HTMLDivElement>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="relative w-full overflow-hidden bg-white">
      {/* Medical textured background */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-medical-texture opacity-[0.35]"
      />

      {/* Page container */}
      <div
        className="
          relative mx-auto max-w-[1440px]
          px-4 sm:px-6 lg:px-12
          pt-20 sm:pt-24 lg:pt-32
          pb-20 sm:pb-24 lg:pb-32
        "
      >
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          {/* Title Section */}
          <div
            ref={title.ref}
            className={`
              text-center
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
            <h2
              className="
                text-primary font-semibold leading-tight
                text-[1.6rem]
                sm:text-[2.1rem]
                md:text-[2.5rem]
                lg:text-[2.8rem]
                xl:text-[3rem]
                mb-4
              "
            >
              What Our Patients Say
            </h2>
</div>
            <p className="max-w-2xl mx-auto text-gray-500">
              Real stories from real people who experienced the future of
              immobilization.
            </p>
          

          {/* Testimony Grid */}
          <section className="max-w-7xl mx-auto w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {TESTIMONIES.map((item) => (
              <TestimonyCard
                key={item.id}
                image={item.image}
                text={item.shortText}
                onMore={() => setActiveTestimony(item)}
              />
            ))}
          </section>


          
        </div>
        <VideoSection/>
      </div>

      {/* Modal */}
      {activeTestimony && (
        <TestimonyModal
          testimony={activeTestimony}
          onClose={() => setActiveTestimony(null)}
        />
      )}
    </main>
  );
};

export default TestimonyWrapper;
